import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook } from 'lucide-react';
import { navigation, siteConfig } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-[var(--line)]">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-16">
        {/* Left-aligned small elegant logo above the info grid */}
        <div className="flex justify-start mb-12">
          <img
            src={siteConfig.heroImage}
            alt="PRESTIGE Beauty & Wellness"
            className="footer-logo select-none"
            draggable="false"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <h4 className="section-eyebrow">Navigatsioon</h4>
            <ul className="space-y-3 mt-5">
              {navigation.map((item) => {
                if (item.href === '/broneerimine') {
                  return (
                    <li key={item.href}>
                      <a
                        href={siteConfig.bookingUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-brand hover:text-gold transition-colors"
                      >
                        {item.label}
                      </a>
                    </li>
                  );
                }
                return (
                  <li key={item.href}>
                    <Link to={item.href} className="text-sm text-brand hover:text-gold transition-colors">
                      {item.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          <div>
            <h4 className="section-eyebrow">Kontakt</h4>
            <ul className="space-y-3 mt-5 text-sm">
              <li>
                <div className="text-brand-muted text-xs tracking-[0.2em] uppercase">Telefon</div>
                <a href={`tel:${siteConfig.contact.phone}`} className="text-brand hover:text-gold transition-colors">
                  {siteConfig.contact.phone}
                </a>
              </li>
              <li>
                <div className="text-brand-muted text-xs tracking-[0.2em] uppercase">E-post</div>
                <a href={`mailto:${siteConfig.contact.email}`} className="text-brand hover:text-gold transition-colors">
                  {siteConfig.contact.email}
                </a>
              </li>
              <li>
                <div className="text-brand-muted text-xs tracking-[0.2em] uppercase">Aadress</div>
                <span className="text-brand">{siteConfig.contact.address}</span>
              </li>
              <li className="pt-2">
                <div className="text-brand-muted text-xs tracking-[0.2em] uppercase mb-3">Jälgi meid</div>
                <div className="flex items-center gap-4">
                  {siteConfig.socials.map((s) => {
                    const Icon = s.key === 'instagram' ? Instagram : Facebook;
                    return (
                      <a
                        key={s.key}
                        href={s.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={s.label}
                        title={s.label}
                        className="text-brand hover:text-gold transition-colors"
                      >
                        <Icon className="w-[18px] h-[18px]" strokeWidth={1.4} />
                      </a>
                    );
                  })}
                  <a
                    href="https://app.stebby.eu/group/prestige.beauty.wellness"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Stebby"
                    title="Stebby"
                    data-testid="footer-stebby-link"
                    className="opacity-90 hover:opacity-100 transition-opacity"
                  >
                    <img src="/stebby-icon.png" alt="Stebby" className="h-[18px] w-auto" draggable="false" />
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[var(--line)] text-xs text-brand-muted text-center tracking-wider">
          {siteConfig.copyright}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
